import overdueIcon from './images/overdue-icon.svg'
import todayIcon from './images/today-icon.svg'
import urgentIcon from './images/urgent-icon.svg'
import upcomingIcon from './images/upcoming-icon.svg'

class Deadline {
    date: Date;
    todayDate: Date;
    diffTime: number;
    diffDays: number;
    deadline: string;
    diffDaysText: string;
    deadlineColor: string;
    borderColor: string;
    srcIcon: string;

    constructor(date: Date) {
        this.date = date;
        this.todayDate = new Date();
        this.diffTime = this.date.getTime() - this.todayDate.getTime();
        this.diffDays = Math.ceil(this.diffTime / (1000 * 60 * 60 * 24));
        this.deadline = this.date.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'Asia/Bangkok'
        });
        if (this.diffDays < 0) {
            this.diffDaysText = `เลยกำหนด ${Math.abs(this.diffDays)} วัน`;
        }
        else if (this.diffDays === 0) {
            this.diffDaysText = 'ครบกำหนดวันนี้';
        }
        else if (this.diffDays === 1) {
            this.diffDaysText = 'ครบกำหนดพรุ่งนี้';
        }
        else {
            this.diffDaysText = `เหลืออีก ${this.diffDays} วัน`;
        }
        if (this.diffDays < 0) {
            this.deadlineColor = '#D30000';
            this.borderColor = 'rgba(255, 89, 89, 0.75)';
            this.srcIcon = overdueIcon;
        }
        else if (this.diffDays <= 7) {
            this.deadlineColor = '#D36500';
            this.borderColor = 'rgba(255, 189, 89, 0.90)';
            this.srcIcon = this.diffDays == 0 ? todayIcon : urgentIcon;
        }
        else {
            this.deadlineColor = '#626262';
            this.borderColor = 'rgba(196, 196, 196, 0.75)';
            this.srcIcon = upcomingIcon;
        }
    }

    compareDeadlineDate(deadline: Deadline) {
        const diffDays = this.diffDays - deadline.diffDays
        if (diffDays < 0) {
            return `ลดระยะเวลาลง \n${Math.abs(diffDays)} วัน`
        }
        else if (diffDays > 0) {
            return `ขยายเวลาเพิ่ม \n${diffDays} วัน`
        }
        else {
            return `ไม่มีการเปลี่ยนแปลง`
        }
    }

}

export default Deadline;